module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"ticket_detail.field.drone":"Drone","ticket_detail.field.company":"ศูนย์","ticket_detail.field.drone.name":"{serialNo} ({name})","ticket_detail.field.drone.model":"รุ่น","ticket_detail.field.link_services":"อ้างอิงใบซ่อม","ticket_detail.field.status":"สถานะ","ticket_detail.field.status.ticket":"Ticket"}}')
  delete Component.options._Ctor
}
